import React, { memo } from 'react';
import {
    FileTextTwoTone,
    FileUnknownTwoTone,
    FileExclamationTwoTone,
    FileAddTwoTone,
    FolderAddTwoTone,
    FolderOpenTwoTone,
    QuestionCircleTwoTone,
    PlusCircleTwoTone,
    CopyTwoTone,
    EditTwoTone,
    BankTwoTone,
    CalendarTwoTone,
    ContainerTwoTone,
    CompassTwoTone,
    CreditCardTwoTone,
    CustomerServiceTwoTone,
    HomeTwoTone,
    PhoneTwoTone,
    NotificationTwoTone,
    SafetyCertificateTwoTone,
    PlayCircleTwoTone,
    PauseCircleTwoTone,
    MinusCircleTwoTone,
    InfoCircleTwoTone,
    ExclamationCircleTwoTone,
    CloseCircleTwoTone,
    CloseSquareTwoTone,
    CheckCircleTwoTone,
    CheckSquareTwoTone,
    ClockCircleTwoTone,
    WarningTwoTone,
    StopTwoTone,
    DeleteTwoTone,
    SnippetsTwoTone,
    DiffTwoTone,
    HighlightTwoTone,
    PieChartTwoTone,
    BoxPlotTwoTone,
    FundTwoTone,
    SlidersTwoTone,
    AccountBookTwoTone,
    AlertTwoTone,
    ApiTwoTone,
    AppstoreTwoTone,
    AudioTwoTone,
    BellTwoTone,
    BookTwoTone,
    BugTwoTone,
    BuildTwoTone,
    BulbTwoTone,
    CalculatorTwoTone,
    CameraTwoTone,
    CarTwoTone,
    CarryOutTwoTone,
    CiCircleTwoTone,
    CiTwoTone,
    CloudTwoTone,
    CodeTwoTone,
    ContactsTwoTone,
    ControlTwoTone,
    CopyrightTwoTone,
    CrownTwoTone,
    DashboardTwoTone,
    DatabaseTwoTone,
    DislikeTwoTone,
    DollarTwoTone,
    EnvironmentTwoTone,
    EuroTwoTone,
    ExperimentTwoTone,
    EyeTwoTone,
    FileExcelTwoTone,
    FileTwoTone,
    FileImageTwoTone,
    FileMarkdownTwoTone,
    FilePdfTwoTone,
    FilePptTwoTone,
    FileWordTwoTone,
    FileZipTwoTone,
    FilterTwoTone,
    FireTwoTone,
    FlagTwoTone,
    FolderTwoTone,
    FunnelPlotTwoTone,
    GiftTwoTone,
    GoldTwoTone,
    HddTwoTone,
    HeartTwoTone,
    HourglassTwoTone,
    IdcardTwoTone,
    InteractionTwoTone,
    LayoutTwoTone,
    LikeTwoTone,
    LockTwoTone,
    MailTwoTone,
    MedicineBoxTwoTone,
    MessageTwoTone,
    MobileTwoTone,
    PictureTwoTone,
    PlaySquareTwoTone,
    PrinterTwoTone,
    ProfileTwoTone,
    ProjectTwoTone,
    PushpinTwoTone,
    ReconciliationTwoTone,
    RocketTwoTone,
    SaveTwoTone,
    ScheduleTwoTone,
    SecurityScanTwoTone,
    SettingTwoTone,
    ShopTwoTone,
    ShoppingTwoTone,
    StarTwoTone,
    SwitcherTwoTone,
    TabletTwoTone,
    TagTwoTone,
    TagsTwoTone,
    ThunderboltTwoTone,
    ToolTwoTone,
    TrademarkCircleTwoTone,
    TrophyTwoTone,
    UnlockTwoTone,
    UsbTwoTone,
    VideoCameraTwoTone,
    WalletTwoTone,
} from '@ant-design/icons';

const iconsMap = {
    FileText: FileTextTwoTone,
    FileUnknown: FileUnknownTwoTone,
    FileExclamation: FileExclamationTwoTone,
    FileAdd: FileAddTwoTone,
    FolderAdd: FolderAddTwoTone,
    FolderOpen: FolderOpenTwoTone,
    QuestionCircle: QuestionCircleTwoTone,
    PlusCircle: PlusCircleTwoTone,
    Copy: CopyTwoTone,
    Edit: EditTwoTone,
    Bank: BankTwoTone,
    Calendar: CalendarTwoTone,
    Container: ContainerTwoTone,
    Compass: CompassTwoTone,
    CreditCard: CreditCardTwoTone,
    CustomerService: CustomerServiceTwoTone,
    Home: HomeTwoTone,
    Phone: PhoneTwoTone,
    Notification: NotificationTwoTone,
    SafetyCertificate: SafetyCertificateTwoTone,
    PlayCircle: PlayCircleTwoTone,
    PauseCircle: PauseCircleTwoTone,
    MinusCircle: MinusCircleTwoTone,
    InfoCircle: InfoCircleTwoTone,
    ExclamationCircle: ExclamationCircleTwoTone,
    CloseCircle: CloseCircleTwoTone,
    CloseSquare: CloseSquareTwoTone,
    CheckCircle: CheckCircleTwoTone,
    CheckSquare: CheckSquareTwoTone,
    ClockCircle: ClockCircleTwoTone,
    Warning: WarningTwoTone,
    Stop: StopTwoTone,
    Delete: DeleteTwoTone,
    Snippets: SnippetsTwoTone,
    Diff: DiffTwoTone,
    Highlight: HighlightTwoTone,
    PieChart: PieChartTwoTone,
    BoxPlot: BoxPlotTwoTone,
    Fund: FundTwoTone,
    Sliders: SlidersTwoTone,
    AccountBook: AccountBookTwoTone,
    Alert: AlertTwoTone,
    Api: ApiTwoTone,
    Appstore: AppstoreTwoTone,
    Audio: AudioTwoTone,
    Bell: BellTwoTone,
    Book: BookTwoTone,
    Bug: BugTwoTone,
    Build: BuildTwoTone,
    Bulb: BulbTwoTone,
    Calculator: CalculatorTwoTone,
    Camera: CameraTwoTone,
    Car: CarTwoTone,
    CarryOut: CarryOutTwoTone,
    CiCircle: CiCircleTwoTone,
    Ci: CiTwoTone,
    Cloud: CloudTwoTone,
    Code: CodeTwoTone,
    Contacts: ContactsTwoTone,
    Control: ControlTwoTone,
    Copyright: CopyrightTwoTone,
    Crown: CrownTwoTone,
    Dashboard: DashboardTwoTone,
    Database: DatabaseTwoTone,
    Dislike: DislikeTwoTone,
    Dollar: DollarTwoTone,
    Environment: EnvironmentTwoTone,
    Euro: EuroTwoTone,
    Experiment: ExperimentTwoTone,
    Eye: EyeTwoTone,
    FileExcel: FileExcelTwoTone,
    File: FileTwoTone,
    FileImage: FileImageTwoTone,
    FileMarkdown: FileMarkdownTwoTone,
    FilePdf: FilePdfTwoTone,
    FilePpt: FilePptTwoTone,
    FileWord: FileWordTwoTone,
    FileZip: FileZipTwoTone,
    Filter: FilterTwoTone,
    Fire: FireTwoTone,
    Flag: FlagTwoTone,
    Folder: FolderTwoTone,
    FunnelPlot: FunnelPlotTwoTone,
    Gift: GiftTwoTone,
    Gold: GoldTwoTone,
    Hdd: HddTwoTone,
    Heart: HeartTwoTone,
    Hourglass: HourglassTwoTone,
    Idcard: IdcardTwoTone,
    Interaction: InteractionTwoTone,
    Layout: LayoutTwoTone,
    Like: LikeTwoTone,
    Lock: LockTwoTone,
    Mail: MailTwoTone,
    MedicineBox: MedicineBoxTwoTone,
    Message: MessageTwoTone,
    Mobile: MobileTwoTone,
    Picture: PictureTwoTone,
    PlaySquare: PlaySquareTwoTone,
    Printer: PrinterTwoTone,
    Profile: ProfileTwoTone,
    Project: ProjectTwoTone,
    Pushpin: PushpinTwoTone,
    Reconciliation: ReconciliationTwoTone,
    Rocket: RocketTwoTone,
    Save: SaveTwoTone,
    Schedule: ScheduleTwoTone,
    SecurityScan: SecurityScanTwoTone,
    Setting: SettingTwoTone,
    Shop: ShopTwoTone,
    Shopping: ShoppingTwoTone,
    Star: StarTwoTone,
    Switcher: SwitcherTwoTone,
    Tablet: TabletTwoTone,
    Tag: TagTwoTone,
    Tags: TagsTwoTone,
    Thunderbolt: ThunderboltTwoTone,
    Tool: ToolTwoTone,
    TrademarkCircle: TrademarkCircleTwoTone,
    Trophy: TrophyTwoTone,
    Unlock: UnlockTwoTone,
    Usb: UsbTwoTone,
    VideoCamera: VideoCameraTwoTone,
    Wallet: WalletTwoTone,
} as const;

interface TagIconProps {
    name: string;
    size?: number;
}

const DEFAULT_SIZE = 16;

export const icons = Object.keys(iconsMap);

const TagIcon: React.FC<TagIconProps> = memo(({ name, size }: TagIconProps) => {
    const IconComponent = iconsMap[name];

    if (!IconComponent) return null;

    return (
        <IconComponent
            twoToneColor="#D2AB67"
            style={{ fontSize: `${size || DEFAULT_SIZE}px` }}
        />
    );
});

export default TagIcon;
